import React from "react";

// Словник для назв кнопок-фільтрів
const subjectTypeMap = {
  partner_property: "Властивості",
};

// Словник для назв дій
const actionTypeMap = {
  partner_property_updated: "Оновив(ла) властивості",
  partner_property_created: "Встановив(ла) властивості",
  partner_property_deleted: "Видалив(ла) властивості",
};

// Словник для назв полів у 'properties'
const propertyKeyMap = {
  price: "Ціна",
  availability: "Наявність",
  is_active: "Активність",
  property_id: "Тип ціни",
};

/**
 * Допоміжна функція для форматування значень (особливо booleans)
 */
const formatValue = (key, value) => {
  if (key === "property_id") {
    if (value === 1) {
      return "Готівка";
    }
    if (value === 2) {
      return "Безготівка";
    }
  }
  if (key === "availability" || key === "is_active") {
    return value ? "Так" : "Ні";
  }
  return value !== null && value !== undefined ? value : "пусто";
};

/**
 * Спеціальна функція-рендер для відображення 'properties'.
 */
const renderPropertyChanges = (properties) => {
  const { new_values, old_values, deleted_values } = properties;
  // Оновлення
  if (new_values && old_values) {
    return (
      <ul className="history-item__changes">
        {Object.keys(new_values).map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="old-value">{formatValue(key, old_values[key])}</span>
            <span> → </span>
            <span className="new-value">{formatValue(key, new_values[key])}</span>
          </li>
        ))}
      </ul>
    );
  }

  // Створення
  if (new_values) {
    return (
      <ul className="history-item__changes">
        {Object.keys(new_values).map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="new-value">{formatValue(key, new_values[key])}</span>
          </li>
        ))}
      </ul>
    );
  }

  // Видалення
  if (deleted_values) {
    const meaningfulKeys = Object.keys(deleted_values).filter(
      (key) => key !== "sku" && deleted_values[key] !== null
    );

    if (meaningfulKeys.length === 0) return null;

    return (
      <ul className="history-item__changes deleted">
        {meaningfulKeys.map((key) => (
          <li key={key}>
            <strong>{propertyKeyMap[key] || key}: </strong>
            <span className="deleted-value">
              {formatValue(key, deleted_values[key])}
            </span>
          </li>
        ))}
      </ul>
    );
  }

  return null;
};

export const partnerHistoryConfig = {
  subjectTypeMap,
  actionTypeMap,
  renderPropertyChanges,
};
